var React = require('react');

function Statements (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10 0C10.266 0 10.52 0.105 10.707 0.293L15.707 5.293C15.895 5.48 16 5.734 16 6V18C16 19.103 15.103 20 14 20H2C0.897 20 0 19.103 0 18V2C0 0.897 0.897 0 2 0H10ZM9 2H2V18H14V7H11C9.897 7 9 6.103 9 5V2ZM11.5 15C11.776 15 12 15.224 12 15.5C12 15.776 11.776 16 11.5 16H4.5C4.224 16 4 15.776 4 15.5C4 15.224 4.224 15 4.5 15H11.5ZM11.5 12C11.776 12 12 12.224 12 12.5C12 12.776 11.776 13 11.5 13H4.5C4.224 13 4 12.776 4 12.5C4 12.224 4.224 12 4.5 12H11.5ZM11.5 9C11.776 9 12 9.224 12 9.5C12 9.776 11.776 10 11.5 10H4.5C4.224 10 4 9.776 4 9.5C4 9.224 4.224 9 4.5 9H11.5ZM6.5 6C6.776 6 7 6.224 7 6.5C7 6.776 6.776 7 6.5 7H4.5C4.224 7 4 6.776 4 6.5C4 6.224 4.224 6 4.5 6H6.5ZM11 3.414V5H12.586L11 3.414Z","fill":"#414141"}));
}

Statements.defaultProps = {"width":"20","height":"20","viewBox":"0 0 16 20","fill":"none"};

module.exports = Statements;

Statements.default = Statements;
